import { CommonPopupService } from '@CaseOne/Common/popup/services/popup.service';
import { Inject, Injectable, Injector } from '@angular/core';
import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { TransitionService } from '@uirouter/core';
import { CommonPopupOptions } from '@CaseOne/Common/popup/popup-options';
import { CommonPopup } from '@CaseOne/Common/popup/popup';
import { DOCUMENT } from '@angular/common';


// Only for CommonDialogFactoryService
@Injectable({
	providedIn: 'root',
})
export class CommonDialogPopupService extends CommonPopupService {
	constructor (
		overlay: Overlay,
		injector: Injector,
		transitionService: TransitionService,
		@Inject(DOCUMENT) document: Document,
		overlayContainer: OverlayContainer
	) {
		super(overlay, injector, transitionService, document, overlayContainer);
	}

	open (options: CommonPopupOptions): CommonPopup {
		options.isOverlapped = true;
		return super.open(options);
	}

	protected createBackgroundOverlay() {
		// nothing
	}

	protected removeBackground () {
		// nothing
	}
}
